import { ProvinceCode } from '@/Domain/Localization/Province'
import { County, CountyRepository, CountyCode, CountyName } from '@/Domain/Localization/County'

async function wait (ms: number) {
  return new Promise(resolve => {
    setTimeout(resolve, ms)
  })
}

interface StoredCounties {
  [key: number]: County[];
}
const counties: StoredCounties = {
  15: [
    new County(new CountyCode(150001), new CountyName('Ames')),
    new County(new CountyCode(150002), new CountyName('Betanzos')),
    new County(new CountyCode(150003), new CountyName('Santiago'))
  ],
  27: [
    new County(new CountyCode(270001), new CountyName('Monforte')),
    new County(new CountyCode(270002), new CountyName('Ribadeo'))
  ],
  32: [
    new County(new CountyCode(320001), new CountyName('Pereiro de Aguiar')),
    new County(new CountyCode(320002), new CountyName('Verín'))
  ],
  36: [
    new County(new CountyCode(360001), new CountyName('Cangas')),
    new County(new CountyCode(360002), new CountyName('Pontevedra')),
    new County(new CountyCode(360003), new CountyName('Mos')),
    new County(new CountyCode(360004), new CountyName('Nigrán'))
  ]
}

export class InMemoryCountyRepository implements CountyRepository {
  async byProvinceId (provinceCode: ProvinceCode): Promise<County[]> {
    await wait(400)
    const code = provinceCode.value()
    let foundCounties: County[] = []
    for (const key in counties) {
      if (key === code.toString()) {
        foundCounties = counties[code]
      }
    }
    return foundCounties
  }
}
